import { createAdminAxios } from "@libertify/auth/refine-adapter";
import { API_URL, HTTP_MAINTENANCE_STATUS } from "@/constants";
import { authService } from "./authService";

const adminAxios = createAdminAxios({
  service: authService,
  apiUrl: API_URL,
  maintenanceStatus: HTTP_MAINTENANCE_STATUS,
});

const { instance, setupInterceptors, resetRefreshState, resetPendingRequests } =
  adminAxios;

export default instance;
export { setupInterceptors, resetRefreshState, resetPendingRequests };
export type { CustomAxiosError } from "@libertify/auth/refine-adapter";
